import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'fitness-force-campaign-name',
  templateUrl: './campaign-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterModule, TooltipModule, TranslateModule, AsyncPipe]
})
export class CampaignNameComponent {
  private router = inject(Router);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);


  onGoToRoute(url:string, columnData:any){
    if(url)
     this.router.navigate([url, columnData.id || columnData.campaign_id || columnData.guid]);
  }

}